import axios from '@/http'

class ImgUploader {
	/* 获取阿里云oss图片上传接口签名 */
	_getAliOssConfig() {
		const url = `/zwy/api/file/get/ALiYunInfo`
		return axios.get(url).then((res) => {
			return Promise.resolve(res.data)
		})
	}
	/* 阿里云 oss 图片存储 */
	async postImgUpload(imgFile) {
		/**
     * imgFile--图片file文件
     */
		let aliOssConfig = await this._getAliOssConfig()
		let { accessid, dir, host, policy, signature } = aliOssConfig
		let formData = new FormData()
		let contentLen = Math.round(imgFile.size * 100 / 1024) / 100
		formData.append('Content-Length', contentLen)
		formData.append('OSSAccessKeyId', accessid)
		formData.append('policy', policy)
		formData.append('signature', signature)
		formData.append('multipart_params', 'new_multipart_params')
		/* 文件名字 */
		const timestamp = new Date().getTime()
		formData.append('key', dir + timestamp + imgFile.name)
		// formData.append('key', dir  + imgFile.name)
		formData.append('dir', dir)
		formData.append('success_action_status', '200')
		/* 文件必须声明在最后，否则异常 */
		formData.append('file', imgFile)
		return axios
			.post(host, formData, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
			.then((res) => {
				if (res.status === 200) {
					/* 上传成功 */
					return Promise.resolve({
						errorCode: 0,
						imgUrl: `${host}/${dir}${timestamp}${imgFile.name}`
					})
				} else {
					/* 上传失败 */
					return Promise.resolve({
						errorCode: 1,
						imgUrl: null
					})
				}
			})
	}
}

export default ImgUploader
